import React from 'react'
import styled, { keyframes } from "styled-components";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ClaroSDKService } from '../../../services/sdk/ClaroSDKService';
import { executeTaggeo } from '../../../store/actions';
import { getMessage } from '../../organisms/utils';

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

const Overlay = styled.div`
    height: 100%;
    width: calc(100% - 32px);
    background-color: rgba(0, 0, 0, 0.65);
    padding: 25px 16px 16px 16px;
    position: fixed;
    top: 0px;
    left: 0px; 
    animation: ${props => props.isOpen ? fadeIn : fadeOut} 0.1s ease-in-out; 
`;

const Card = styled.div`
    background-color: #fff;
    padding: 16px 16px 48px 16px;
    width: inherit;
    border-radius: 5px
`;

const CloseButton = styled.img`
    margin-left: auto;
    display: block;
    width: 24px;
    height: 24px;
    margin-bottom: 10px;
`;

const Message = styled.p`
    margin: 0px 0px 16px 0px;
    font-family: AMX-Regular;
    font-size: 18px;
    line-height: 26px;
    color: #323232;
    text-align: center;
`;

const PhoneNumber = styled.p`
    margin: 0px 0px 31.5px 0px;
    font-family: AMX-Bold;
    font-size: 20px;
    line-height: 28px;
    color: #222222;
    text-align: center;
`;

const MainButton = styled.button`
    width: 100%;
    padding: 10px;
    background: #8030a1;
    color: #ffffff;
    font-family: AMX-Bold;
    font-size: 16px;
    line-height: 24px;
    margin: 0px 0px 31.5px 0px;
    border: none;
    border-radius: 100px;
`;

const LinkButton = styled.button`
    width: 100%;
    padding: 0px;
    background: #ffffff;
    color: #0071d1;
    font-family: AMX-Bold;
    font-size: 16px;
    line-height: 24px;
    margin: 0px;
    border: none;
    text-decoration: underline;
`;

const ModalCardHE = ({ isOpen, close, messages, paymentsConfig, executeTaggeo }) => {
    const [text, setText] = React.useState("");
    const [phoneNumber, setPhoneNumber] = React.useState("");
    const [buttonText, setButtonText] = React.useState("");
    const [linkText, setLinkText] = React.useState("");

    React.useEffect(() => {    
        const CP = getMessage(messages, "CP0022", "MiniAppTelcel");    
        
        if (CP && CP.data) {
            const { data } = CP;
            setText(data.subject);
            setButtonText(data.buttons[0] ? data.buttons[0] : buttonText);
            setLinkText(data.buttons[1] ? data.buttons[1] : linkText);
        }

    }, [messages])

    React.useEffect(() => {
        setPhoneNumber(paymentsConfig.msisdn ? paymentsConfig.msisdn.toString() : "");
    }, [paymentsConfig])

    React.useEffect(() => {
        if (isOpen) {
             executeTaggeo({
                step: "Formulario de pago",
                action: "View message",
                id_message: "Envío código al número"
            })
        }       
    }, [isOpen])

    const handleOpenLogin = (withMsisdn = false) => {
        let action = "";

        if (withMsisdn) {
            action = "Click message Entendido";
            //
            const msisdn = phoneNumber ? phoneNumber : "";
            ClaroSDKService.openLogin(msisdn);
        } else {
            action = "Click message Cambiar número";
            //
            ClaroSDKService.openLogin();
        }
        
        close();  
        
        setTimeout(() => {
            executeTaggeo({
                step: "Formulario de pago",
                action: action,
                id_message: "Envío código al número"
            });
        }, 500);
    }

    const handleClose = () => {
        executeTaggeo({
            step: "Formulario de pago",
            action: "Click message Cerrar",
            id_message: "Envío código al número"
        });

        //

        close();
    }

    return (
        <>
            {
                isOpen &&
                <Overlay isOpen={isOpen}>
                    <Card>
                        {/* Close button */}
                        <CloseButton src='/images/icono_salir_contenedor.png' onClick={() => handleClose()} />

                        {/* Text */}
                        <Message>
                            <span dangerouslySetInnerHTML={{ __html: text }} />
                        </Message>

                        {/* Phone number */}
                        <PhoneNumber>
                            <span dangerouslySetInnerHTML={{ __html: phoneNumber }} />
                        </PhoneNumber>

                        {/* Button */}
                        <MainButton onClick={() => handleOpenLogin(true)}>
                            <span dangerouslySetInnerHTML={{ __html: buttonText }} />
                        </MainButton>

                        {/* Link */}
                        <LinkButton onClick={() => handleOpenLogin()}>
                            <span dangerouslySetInnerHTML={{ __html: linkText }} />
                        </LinkButton>
                    </Card>
                </Overlay>
            }
        </>
    )

}

const mapStateToProps = (state) => {
    const { payments } = state;
    const messages = payments.messages;
    const paymentsConfig = payments.PAYMENT_SERVICE_CONF;
    return {
        messages,
        paymentsConfig
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            executeTaggeo
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCardHE)